import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '@/src/renderer/lib/db/indexeddb'
import type { Tag } from '@/src/renderer/lib/db/models'
import { scheduleSync } from '../../../lib/sync/sync-engine'

const TAG_COLORS = ['#7c3aed', '#2563eb', '#16a34a', '#dc2626', '#d97706', '#0891b2', '#db2777', '#059669']

export function useTags() {
  const tags = useLiveQuery(() => db.tags.toArray(), [], []) as Tag[]

  const createTag = async (name: string): Promise<Tag> => {
    const count = await db.tags.count()
    const color = TAG_COLORS[count % TAG_COLORS.length]
    const tag = await db.createTag({
      name: name.trim(),
      color,
      description: null,
    })
    scheduleSync()
    return tag
  }

  return { tags, createTag }
}
